import { render, staticRenderFns } from "./PlantingSocExportLahanMu.vue?vue&type=template&id=63b959da"
import script from "./PlantingSocExportLahanMu.vue?vue&type=script&lang=js"
export * from "./PlantingSocExportLahanMu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports